export default defineNuxtRouteMiddleware((to) => {
    const { activeSite } = useMultisite();
    const group = activeSite.value?.group;

    if (group !== 'patients' && to.path.startsWith('/updates')) {
        return navigateTo(to.path.replace(/^\/updates/, '/news'));
    }

    if (group === 'patients' && to.path.startsWith('/news')) {
        return navigateTo(to.path.replace(/^\/news/, '/updates'));
    }
});
